import { Link } from "react-router-dom";
import "../styles/pagoResultado.css";

export default function PagoFallido() {
  return (
    <div className="resultado-container">
      <div className="resultado-card error">
        <div className="resultado-icon error">✕</div>

        <h1>Pago rechazado</h1>

        <p className="resultado-texto">
          El pago no pudo ser procesado correctamente.
        </p>

        <p className="resultado-subtexto">
          No se realizó ningún cargo.<br />
          Puedes intentar nuevamente o elegir otro curso.
        </p>

        <div className="resultado-actions">
          <Link to="/cursos" className="btn-primario">
            Volver a cursos
          </Link>

          <Link to="/" className="btn-secundario">
            Ir al inicio
          </Link>
        </div>
      </div>
    </div>
  );
}
